import {
  Directive,
  ElementRef,
  inject,
  input,
  OnInit,
  Renderer2,
} from '@angular/core';
import { IStatusInfo } from '../model';
import { TranslocoService } from '@jsverse/transloco';

@Directive({
  selector: '[libStatus]',
  standalone: true,
})
export class Status implements OnInit {
  $translocoService = inject(TranslocoService);

  prefix = input('');

  libStatus = input.required<number>();

  enum = input.required<any>();

  statusStyles = input.required<IStatusInfo[]>();

  ngOnInit(): void {
    this.applyStyle();
    this.updateTranslatedStatus();

    this.$translocoService.langChanges$.subscribe(() => {
      this.updateTranslatedStatus();
    });
  }

  private el = inject(ElementRef);

  private renderer = inject(Renderer2);

  private applyStyle() {
    const style = this.statusStyles().find(
      (el) => el.status == this.libStatus(),
    );
    if (style) {
      this.renderer.setStyle(this.el.nativeElement, 'color', style.color);
      this.renderer.setStyle(
        this.el.nativeElement,
        'background-color',
        style.backgroundColor,
      );

      this.renderer.setStyle(this.el.nativeElement, 'padding', '4px 12px');
      this.renderer.setStyle(this.el.nativeElement, 'border-radius', '9999px'); // pill shape
      this.renderer.setStyle(this.el.nativeElement, 'display', 'inline-block');
      this.renderer.setStyle(this.el.nativeElement, 'font-weight', 500);
    }
  }

  private updateTranslatedStatus() {
    const enumKey = this.enum()[this.libStatus()] ?? 'status_not_found';
    const prefix = this.prefix();

    if (!prefix) {
      this.el.nativeElement.innerHTML = this.$translocoService.translate(enumKey);
      return;
    }

    const prefixedKey = `${prefix}.${enumKey}`;
    const translatedPrefixedKey = this.$translocoService.translate(prefixedKey);

    // If prefixed key is missing, fall back to legacy non-prefixed key.
    this.el.nativeElement.innerHTML =
      translatedPrefixedKey !== prefixedKey
        ? translatedPrefixedKey
        : this.$translocoService.translate(enumKey);
  }
}
